<template>
    <div class="study-request__row-expand">
        <div class="study-request__row-expand-info">
            <div class="row-expand-info__left">
                <span class="study-request__row-expand-label">
                    {{ $t('Контакты') }}
                </span>
                <p>
                    {{ row.detail.fullName }}<br>
                    {{ row.detail.phone }} {{ row.detail.email }}
                </p>
            </div>
            <div class="row-expand-info__right">
                <span class="study-request__row-expand-label">
                    {{ $t('Компания, в которой будет проводиться обучение') }}
                </span>
                <p>
                    {{ row.detail.company }} <br>
                    {{ row.detail.employees || $t('Неизвестно') }} {{ $t('участников') }}
                </p>
            </div>
        </div>
        <div class="study-request__row-expand-segments">
            <span class="study-request__row-expand-label">
                {{ $t('Тематика') }}
            </span>
            <p v-for="(segment, key) in row.detail.segments" :key="key">
                {{ segment || '-' }}
            </p>
        </div>
        <div class="study-request__row-expand-comment">
            <span class="study-request__row-expand-label">
                {{ $t('Комментарий') }}
            </span>
            <p v-if="row.detail.comment" v-html="row.detail.comment.split('\n').join('<br>')"></p>
            <p v-else>-</p>
        </div>
    </div>
</template>
<script>
export default {
  name : 'StudyPlanRequestRowExpand',
  props: {
    row: {
      type    : Object,
      required: true,
    },
  },
};

</script>

<style lang="less">
@import url('../../../less/variables');

.study-request__row {
    &-expand {
        padding: 20px 40px !important;
        font-family: @light-font;
        max-width: 700px;
        &-label {
            color: #838688;
            display: inline-block;
            margin-bottom: 8px;
            font-family: @main-font;
        }
        &-text {
            color: #231F20;
        }
        &-segments {
            margin-bottom: 22px;
            & p {
                margin-bottom: 0;
            }
        }
        &-info {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            margin-bottom: 22px;
        }
    }
}
.row-expand-info {
    &__left, &__right {
        width: 100%
    }
    &__left {
        max-width: 160px;
        margin-right: 20px;
    }
    &__right {
        max-width: 305px
    }
}
</style>
